import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PublicReportService {
  constructor(
    public http: HttpClient,
    private authService: AuthService
  ) {}

  GetVinInfo(reportToken?: string) {
    console.log('GetVinInfo');
    try {
      if (reportToken) {
        console.log('vehicle-information get');

        return this.http.get(`${environment().api}/public/report/get/vehicle-information`, {
          headers: {
            'X-Report-Token': reportToken
          }
        });
      }
    } catch (err) {
      console.log(err, 'Error err');
    }
  }
}
